import './style.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ImgContainer from './components/ImgContainer';
import FilterOverlay from './components/FilterOverlay';
import filterData from './data/filter';
import imageData from './data/images';
import ImageOverlay from './components/ImageOverlay';

import { useState, useEffect, useCallback } from 'react';

function App() {
  const [showFilterOverlay, setShowFilterOverlay] = useState(false);

  const images = imageData;
  const [fullImage, setFullImage] = useState(false);
  const searchParams = new URLSearchParams(document.location.search);

  let filterParams = [3, 6, 7, 21, 22];

  if (searchParams.get('f')) {
    let filterParamsStrArr = searchParams.get('f').split(',');

    filterParams = filterParamsStrArr.map((str) => {
      return str !== '' && Number(str);
    });
  }

  filterParams = filterParams.filter(function (element) {
    return Number(element) !== 0;
  });

  //const stattFilters = [3, 6, 7, 21, 22];
  const stattFilters = filterParams;

  const [filters, setFilters] = useState(stattFilters);

  const [filterImages, setFilterImages] = useState(imageData);
  function onFilterClick() {
    setShowFilterOverlay(!showFilterOverlay);
  }
  function closeImageOverlay() {
    setFullImage('');
  }
  function showFullSize(img) {
    const url = `${process.env.PUBLIC_URL}/pictures/${img}`;
    setFullImage(url);
  }
  function removeItemFromFilter(id) {
    const newFilterArray = filters.filter(function (value, index, arr) {
      return value !== id;
    });

    setFilters(newFilterArray);
  }

  const findImages = useCallback(
    (filters) => {
      let newFoundImages = [];

      //no filters, show all images
      if (filters.length === 0) {
        setFilterImages(images);
        return;
      }

      //check if location filters are selected
      const filterLocation = filters.filter(function (value, index, arr) {
        return value > 19 && value < 30;
      });
      //check if standard filters are selected
      const filterIncludes = filters.filter(function (value, index, arr) {
        return value < 11;
      });

      //check if bike filter is selected
      const filterBike = filters.filter(function (value, index, arr) {
        return value === 40;
      });

      //check if shame filter is selected
      const filterShame = filters.filter(function (value, index, arr) {
        return value === 50;
      });

      //check if socks filter is selected
      const filterSocks = filters.filter(function (value, index, arr) {
        return value === 60;
      });

      const nrOfFilterLocation = filterLocation.length;

      for (let k = 0; k < images.length; k++) {
        let showImage = false;
        let showImageLocation = false;

        let showImageBike = false;
        let showImageShame = false;
        let showImageSocks = false;

        for (let i = 0; i < filters.length; i++) {
          //check location
          if (nrOfFilterLocation > 0 && filters[i] > 19 && filters[i] < 30) {
            if (images[k].filter_excl.includes(filters[i])) {
              showImageLocation = true;
            }
            //check bike
          } else if (filters[i] === 40) {
            if (images[k].filter_bike) {
              showImageBike = true;
            }
            //check shame
          } else if (filters[i] === 50) {
            if (images[k].filter_shame === true) {
              showImageShame = true;
            }
            //check socks
          } else if (filters[i] === 60) {
            if (images[k].filter_socks === false) {
              showImageSocks = true;
            }
            //check other filters
          } else {
            if (images[k].filter_incl.includes(filters[i])) {
              showImage = true;
            }
          }
        }

        //CONDITIONS
        let doShow = true;

        // normal filer?
        if (filterIncludes.length > 0 && !showImage) {
          doShow = false;
        }

        //does it match location?
        if (filterLocation.length > 0 && !showImageLocation) {
          doShow = false;
        }

        // bike?
        if (filterBike.length > 0 && !showImageBike) {
          doShow = false;
        }

        // shame on?
        if (filterShame.length > 0 && !showImageShame) {
          doShow = false;
        } else if (filterShame.length > 0 && showImageShame) {
          if (filterLocation.length > 0 && !showImageLocation) {
            doShow = false;
          } else {
            doShow = true;
          }
        }

        // only socks on?
        if (filterSocks.length > 0 && !showImageSocks) {
          doShow = false;
        }

        if (doShow) {
          newFoundImages.push(images[k]);
        }
      }

      setFilterImages(newFoundImages);
    },
    [images]
  );

  useEffect(() => {
    findImages(filters);
  }, [filters, findImages]);

  return (
    <div className='App'>
      <Header
        title='Hva skal jeg gj&oslash;re med flaska n&aring;r jeg har drukket
              opp?'
        description='Pant er enkelt i butikken, men hva skjer med boks eller flaske når
              du er langt fra både hjem og butikk? Med enkle grep kan du sørge for at flasker og bokser ikke kommer på avveie.'
      />

      {images && (
        <ImgContainer
          onFilterClick={onFilterClick}
          images={images}
          filterImages={filterImages}
          filters={filters}
          removeItemFromFilter={removeItemFromFilter}
          showFullSize={showFullSize}
        />
      )}
      {showFilterOverlay && (
        <FilterOverlay
          data={filterData}
          hideFilterOverlay={onFilterClick}
          filterImages={filterImages}
          images={images}
          setFilterImages={setFilterImages}
          filters={filters}
          setFilters={setFilters}
          findImages={findImages}
        />
      )}

      {fullImage && (
        <ImageOverlay
          closeImageOverlay={closeImageOverlay}
          fullImage={fullImage}
        />
      )}
      <Footer />
    </div>
  );
}

export default App;
